const clientId = "1b7c83fc02404e08892183b94c0986a9";
const scope = "playlist-modify-private playlist-modify-public";
const redirectUrl =
  window.location.hostname === "localhost"
    ? "https://localhost:8080/"
    : "https://musicwhereyouare.com";
const authorizationEndpoint = "https://accounts.spotify.com/authorize";
const tokenEndpoint = "https://accounts.spotify.com/api/token";

const currentToken = {
  get accessToken() {
    return sessionStorage.getItem("accessToken") || null;
  },
  get refreshToken() {
    return sessionStorage.getItem("refreshToken") || null;
  },
  get expiresIn() {
    return sessionStorage.getItem("expiresIn") || null;
  },
  get expires() {
    return sessionStorage.getItem("expires") || null;
  },

  save: function(response) {
    const { access_token, refresh_token, expires_in } = response;
    sessionStorage.setItem("accessToken", access_token);
    sessionStorage.setItem("refreshToken", refresh_token);
    sessionStorage.setItem("expiresIn", expires_in);

    const now = new Date();
    const expiry = new Date(now.getTime() + expires_in + 1800000);
    sessionStorage.setItem("expires", expiry);
  }
};

const args = new URLSearchParams(window.location.search);
const code = args.get("code");

export async function getSpotifyToken() {
  const rightNow = new Date();
  if (code) {
    const token = await getToken(code);
    currentToken.save(token);
    sessionStorage.accessToken = currentToken.accessToken;

    // Remove code from URL so we can refresh correctly.
    const url = new URL(window.location.href);
    url.searchParams.delete("code");

    const updatedUrl = url.search ? url.href : url.href.replace("?", "");
    window.history.replaceState({}, document.title, updatedUrl);
    window.location.reload(); // reloads page to ensure that api calls get made with tokens
  } else if (
    !currentToken.accessToken ||
    rightNow > new Date(currentToken.expires)
  ) {
    redirectToSpotifyAuthorize();
  }
}

async function getToken(code) {
  const code_verifier = sessionStorage.getItem("code_verifier");

  const response = await fetch(tokenEndpoint, {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded"
    },
    body: new URLSearchParams({
      client_id: clientId,
      grant_type: "authorization_code",
      code: code,
      redirect_uri: redirectUrl,
      code_verifier: code_verifier
    })
  });

  return await response.json();
}

async function redirectToSpotifyAuthorize() {
  const possible =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  const randomValues = crypto.getRandomValues(new Uint8Array(64));
  const randomString = randomValues.reduce(
    (acc, x) => acc + possible[x % possible.length],
    ""
  );

  const code_verifier = randomString;
  const data = new TextEncoder().encode(code_verifier);
  const hashed = await crypto.subtle.digest("SHA-256", data);

  const code_challenge_base64 = btoa(
    String.fromCharCode(...new Uint8Array(hashed))
  )
    .replace(/=/g, "")
    .replace(/\+/g, "-")
    .replace(/\//g, "_");

  window.sessionStorage.setItem("code_verifier", code_verifier);

  const authUrl = new URL(authorizationEndpoint);
  const params = {
    response_type: "code",
    client_id: clientId,
    scope: scope,
    code_challenge_method: "S256",
    code_challenge: code_challenge_base64,
    redirect_uri: redirectUrl
  };

  authUrl.search = new URLSearchParams(params).toString();
  window.location.href = authUrl.toString(); // Redirect the user to the authorization server for login
}

// export function getSpotifyToken() {
//   const authorizationUrl = `${authorizationEndpoint}?response_type=token&client_id=${clientId}&scope=${encodeURIComponent(
//     scope
//   )}&redirect_uri=${redirectUrl}`;

//   window.open(authorizationUrl, "_self");
// }
